<template>
  <chat-button-dropdown v-if="chatWithPatientAvailable"></chat-button-dropdown>
  <b-nav-item
    v-else
    title="Чат"
    class="mr-25"
  >
    <feather-icon
      icon="MessageSquareIcon"
      size="21"
      @click="openChat(appConstants.chat.type.COLLEAGUES)"
    ></feather-icon>
  </b-nav-item>
</template>

<script>
import {
  BNavItem, BNavItemDropdown
} from 'bootstrap-vue'
import ChatButtonDropdown from '@/core/layouts/components/app-navbar/components/chat-button/ChatButtonDropdown.vue'
import { openChat } from '@/core/layouts/components/app-navbar/components/chat-button/chat'
import { inject } from 'vue'
import { enabledChatMessengers } from '@/composables/chat'

export default {
  name: 'ChatButton',
  components: {
    ChatButtonDropdown, BNavItemDropdown, BNavItem
  },
  setup() {
    const appConstants = inject('appConstants')
    const chatWithPatientAvailable = enabledChatMessengers().length

    return {
      appConstants,
      chatWithPatientAvailable,

      openChat
    }
  }
}
</script>
